<div class="container coding-and-billing-container d-none d-md-block">
  @if (firstheadline | async; as item) {
    <div id="quick-coding-header--row" class="row-flex">
      @if (item.uid=='seqirusCodingBillingQuickReference') {
        <div>
          <!--above headings-->
          <div class="col-flex-lg-12 col-flex-md-12 col-flex-sm-12 col-flex-xs-12 padding-L40">
            @if (item?.headLine) {
              <h2 class="coding--header">{{item.headLine}}</h2>
            }
            @if (item?.subHeadLine) {
              <p class="coding--subhead">{{item.subHeadLine}}</p>
            }
          </div>
          <div class="col-flex-lg-12 col-flex-md-12 col-flex-sm-12 col-flex-xs-12 tabs--desktop-layout d-none d-md-block">
            <!--tabs content-->
            <div class="tab--desktop-holder">
              <div class="tabs--container">
                <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" animationDuration="0ms"
                  class="custom-tab-group">
                  @for (item2 of mergedObject1; track item2; let i = $index) {
                    <div>
                      <mat-tab label="{{item2.h2content}}" class="label">
                        <div class="tabs--container--holder">
                          <div class="tabs--container-content">
                            <div class="tabs_Content_Holder">
                              <div [ngClass]="{'fluad-chart-container-desktop': i === 0, 'flucelvax-chart-container-desktop': i === 1, 'afluria-chart-container-desktop': i !== 0 && i !== 1}"
                                [innerHTML]="item2.content">
                              </div>
                            </div>
                            <a [href]="getpdf(item2.mediaPdf?.url)" target="_blank">{{item2.pdfLinkContent}}<img
                            alt="Download" src="assets/images/icon-download.svg"></a>
                          </div>
                        </div>
                      </mat-tab>
                    </div>
                  }
                </mat-tab-group>
              </div>
            </div>
            <!--bottom references-->
            <div class="tabs-footnote--container">
              <p class="footnotePara1">{{item?.bottom1Content}}</p>
              <p  class="footnotePara2" [innerHTML]="item?.bottom2Content"></p>
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>
<!--for mobile version-->
<div class="container coding-and-billing-container mobile--coding-and-billing-container d-block d-md-none">
  @if (firstheadline | async; as item) {
    <div id="quick-coding-header--row" class="row-flex">
      @if (item.uid=='seqirusCodingBillingQuickMobReference') {
        <div>
          <!--above headings-->
          <div class="col-flex-lg-12 col-flex-md-12 col-flex-sm-12 col-flex-xs-12 padding-L40">
            @if (item?.headLine) {
              <h2 class="coding--header">{{item?.headLine}}</h2>
            }
            @if (item?.subHeadLine) {
              <p class="coding--subhead">{{item?.subHeadLine}}</p>
            }
          </div>
          <div class="row-flex text-center ml-0-mobile">
            <div class="col-md-12 col-sm-12 col-xs-12 mobile-expansion">
              <!--accordion content-->
              <mat-accordion>
                @for (item2 of mergedObject1; track item2; let i = $index) {
                  <div>
                    <mat-expansion-panel class="custom-panel">
                      <!--for above header-->
                      <mat-expansion-panel-header class="custom-panel-header">
                        @if (i == 0) {
                          <mat-panel-title class="custom-panel-title">
                            {{"statictext.fluad" | cxTranslate}}
                          </mat-panel-title>
                        }
                        @if (i == 1) {
                          <mat-panel-title class="custom-panel-title">
                            {{"statictext.flucelvax" | cxTranslate}}
                          </mat-panel-title>
                        }
                      </mat-expansion-panel-header>
                      <div [innerHTML]="item2?.content"></div>
                      <div class="chart-footer">
                        <hr>
                          <!--for download pdf-->
                          <a [href]="getpdf(item2.mediaPdf?.url)">{{item2?.pdfLinkContent}}
                            <img alt="Download" [src]="'assets/images/icon-download.svg'">
                          </a>
                          <!--for italic footnote-->
                          <p class="italic-footnote" [innerHTML]="item2?.h2content"></p>
                          <p class="italic-footnote" [innerHTML]="item2?.position"></p>
                          <p class="italic-footnote text-align-left" [innerHTML]="item2?.name"></p>
                        </div>
                      </mat-expansion-panel>
                    </div>
                  }
                </mat-accordion>
              </div>
            </div>
            <!--bottom references-->
            <div class="tabs-footnote--container mobile-view-footer col-md-12 col-sm-12 col-xs-12 d-block d-md-none">
              <p class="footnotePara1">{{item?.bottom1Content}}</p>
              <p class="footnotePara2" [innerHTML]="item?.bottom2Content"></p>
            </div>
          </div>
        }
      </div>
    }
  </div>